import React from 'react';
import styled from 'styled-components';
import Button from '../common/Button';
import SectionHeader from '../common/SectionHeader';

const BatchSection = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 80px 0;
`;

const BatchContainer = styled.div`
  display: flex;
  gap: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const BatchCard = styled.div`
  flex: 1;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.borders.radius.regular};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.regular};
`;

const BatchHeader = styled.div`
  background-color: ${props => 
    props.upcoming ? props.theme.colors.secondaryColor : props.theme.colors.primaryColor};
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BatchTitle = styled.h3`
  margin-bottom: 0;
  color: white;
  font-size: ${props => props.theme.fontSizes.large};
`;

const BatchStatus = styled.span`
  background-color: ${props => 
    props.upcoming ? props.theme.colors.warningColor : props.theme.colors.successColor};
  color: ${props => 
    props.upcoming ? props.theme.colors.darkColor : 'white'};
  padding: 5px 10px;
  border-radius: ${props => props.theme.borders.radius.small};
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
`;

const BatchBody = styled.div`
  padding: 30px;
`;

const BatchDetailsList = styled.ul`
  list-style: none;
  margin-bottom: 30px;
  
  li {
    margin-bottom: 15px;
    color: ${props => props.theme.colors.grey[700]};
    display: flex;
    align-items: baseline;
    
    &:before {
      content: "•";
      color: ${props => props.theme.colors.primaryColor};
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
    
    strong {
      font-weight: ${props => props.theme.fontWeights.semiBold};
      margin-right: 5px;
      color: ${props => props.theme.colors.secondaryColor};
    }
  }
`;

const BatchDetailsComponent = () => {
  const batches = [
    {
      title: "Current Batch",
      status: "Ongoing",
      upcoming: false,
      details: [
        { label: "Start Date", value: "January 15, 2025" },
        { label: "End Date", value: "February 28, 2025" },
        { label: "Timings", value: "6:30 AM - 8:30 AM (Morning Batch)" },
        { label: "Alternative Timings", value: "7:00 PM - 9:00 PM (Evening Batch)" },
        { label: "Mode", value: "Online Classes" },
        { label: "Seats", value: "Limited seats available" }
      ]
    },
    {
      title: "Next Batch",
      status: "Enrolling",
      upcoming: true,
      details: [
        { label: "Start Date", value: "April 2, 2025" },
        { label: "End Date", value: "May 15, 2025" },
        { label: "Timings", value: "6:30 AM - 8:30 AM (Morning Batch)" },
        { label: "Alternative Timings", value: "7:00 PM - 9:00 PM (Evening Batch)" },
        { label: "Mode", value: "Online Classes" },
        { label: "Early Bird Discount", value: "Available until March 15, 2025" }
      ]
    }
  ];

  return (
    <BatchSection>
      <div className="container">
        <SectionHeader 
          title="Batch Details" 
          subtitle="Choose the batch that fits your schedule" 
        />
        
        <BatchContainer>
          {batches.map((batch, index) => (
            <BatchCard key={index}>
              <BatchHeader upcoming={batch.upcoming}>
                <BatchTitle>{batch.title}</BatchTitle>
                <BatchStatus upcoming={batch.upcoming}>{batch.status}</BatchStatus>
              </BatchHeader>
              
              <BatchBody>
                <BatchDetailsList>
                  {batch.details.map((detail, detailIndex) => (
                    <li key={detailIndex}>
                      <strong>{detail.label}:</strong> {detail.value}
                    </li>
                  ))}
                </BatchDetailsList>
                
                <Button 
                  to="/contact" 
                  variant={batch.upcoming ? "primary" : "secondary"}
                  fullWidth
                >
                  {batch.upcoming ? "Enroll Now" : "Join Waiting List"}
                </Button>
              </BatchBody>
            </BatchCard>
          ))}
        </BatchContainer>
      </div>
    </BatchSection>
  );
};

export default BatchDetailsComponent;
